import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Utensils, Wine, Building2, MapPin, Grid3X3 } from "lucide-react";

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }: CategoryFilterProps) => {
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'kitchen':
        return <Utensils className="h-4 w-4" />;
      case 'bar':
        return <Wine className="h-4 w-4" />;
      case 'restaurant':
        return <Building2 className="h-4 w-4" />;
      case 'external':
        return <MapPin className="h-4 w-4" />;
      default:
        return <Grid3X3 className="h-4 w-4" />;
    }
  };

  const getCategoryLabel = (category: string) => {
    switch (category) {
      case 'all':
        return 'All Areas';
      case 'kitchen':
        return 'Kitchen';
      case 'bar':
        return 'Bar';
      case 'restaurant':
        return 'Restaurant';
      case 'external':
        return 'External';
      default:
        return category.charAt(0).toUpperCase() + category.slice(1);
    }
  };

  const getCategoryCount = (category: string) => {
    if (category === 'all') {
      return categories.length;
    }
    return 1; // Each category has items, exact count would need to be passed from parent
  };

  return (
    <Select value={selectedCategory} onValueChange={onCategoryChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Filter by area" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">
          <div className="flex items-center gap-2">
            <Grid3X3 className="h-4 w-4" />
            <span>All Areas</span>
            <Badge variant="secondary" className="ml-auto text-xs">
              {categories.length + 1}
            </Badge>
          </div>
        </SelectItem>
        
        {categories.map((category) => (
          <SelectItem key={category} value={category}>
            <div className="flex items-center gap-2">
              {getCategoryIcon(category)}
              <span>{getCategoryLabel(category)}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};